import Card from './Card.vue';
import { NAME } from './constants';

export const AttachmentFiles = {
	name: NAME,
	components: {
		Card,
	},
};
